
import { defineComponent, PropType } from 'vue'

// types
import { DispatcherTakeOrderT } from '@/core/types/dispatcher.types'

// enums
import { DispatcherOrderStatusesEnum } from '@/core/enums/dispatcher.enums'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        cheap: Cheap,
        checkbox: Checkbox,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<DispatcherTakeOrderT>,
            default: null,
        },
        checked: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click', 'check'],
    setup(props, { emit }) {
        const emitClick = () => {
            emit('click', props.item.id)
        }

        const emitCheck = () => {
            emit('check', props.item.id)
        }

        return { emitClick, emitCheck, DispatcherOrderStatusesEnum }
    },
})
